import clsx from "clsx";
import { memo } from "react";
import { MdClose } from "react-icons/md";
import CheckBox from "src/components/CheckBox/CheckBox";
import Modal from "src/components/Modal/Modal";
import useModalsStore from "src/store/modalsStore";
import { useTranslation } from "react-i18next";
import SettingsPerDeviceInfoBlock from "../InfoBlock/SettingsPerDeviceInfoBlock/SettingsPerDeviceInfoBlock";
import useUiPreferences from "src/store/useUiPreferences";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

const GlobalAccountsSettingsModal: React.FC = () => {
  const { t } = useTranslation();
  const setUiPreferences = useUiPreferences((s) => s.setUiPreferences);
  const accountsUiPreferences = useUiPreferences((s) => s.accounts);

  const { setShowAccountsSettingsModal } = useModalsStore();

  const onClose = () => setShowAccountsSettingsModal(false);

  return (
    <Modal
      onEscape={() => onClose()}
      className="md:!max-w-[480px] md:!min-w-[280px] md:w-full"
    >
      <Modal.Header
        title="Opciones adicionales de cuentas"
        onClose={() => onClose()}
      />
      <Modal.Body>
        <div className={clsx(["flex", "w-full", "flex-col", "gap-4"])}>
          <SettingsPerDeviceInfoBlock />
          <CheckBox
            label="Usar cuentas inactivas"
            onChange={(isChecked: boolean) => {
              setUiPreferences({
                accounts: {
                  showInactiveAccounts: isChecked,
                },
              });
            }}
            checked={accountsUiPreferences.showInactiveAccounts}
            description="Permitir el uso de cuentas inactivas en este dispositivo."
          />
          <CheckBox
            label="Transacciones sin fondos"
            onChange={(isChecked: boolean) => {
              setUiPreferences({
                accounts: {
                  allowTransfersWithNoFunds: isChecked,
                },
              });
            }}
            checked={accountsUiPreferences.allowTransfersWithNoFunds}
            description="Permitir realizar transacciones aunque no tenga suficientes fondos."
          />
        </div>
      </Modal.Body>
      <Modal.Footer
        actions={[
          {
            text: t("common:buttons.close"),
            onClick: onClose,
            kind: EButtonKind.NORMAL,
            icon: <MdClose size={ICON_SIZES.SM} />,
          },
        ]}
      />
    </Modal>
  );
};

export default memo(GlobalAccountsSettingsModal);
